import {
  CandidatesListOrdering,
  PrincipalAppRow,
} from 'features/Principal/types/candidatesListTypes';
import {
  roleStatusByValue,
  activeStatusByValue,
  LanguagesEnum,
  CandidateCredentialStatus,
  CredentialVerificationStatus,
} from 'utils/typedEnums';

export interface SortOption {
  id: number;
  label: string;
  ordering: CandidatesListOrdering;
}

export const sortOptions: SortOption[] = [
  {
    id: 0,
    label: 'First name',
    ordering: 'first_name',
  },
  {
    id: 1,
    label: 'Last name',
    ordering: 'last_name',
  },
];

export const mockRows: PrincipalAppRow[] = [
  {
    candidate_stage: null,
    has_references: true,
    role: {
      id: 0,
      title: 'Elementary Art Teacher',
      status: roleStatusByValue.active,
      active_status: activeStatusByValue.activeOpen,
    },
    candidate: {
      id: 0,
      first_name: 'Jeremy',
      last_name: 'Christianson',
      email: 'jeremy@example.com',
      nimble_answers: [],
      profile: {
        resume:
          'https://nimblemedia-dev.s3.us-west-1.amazonaws.com/resumes/47103/20240722_1623_resume-sample.pdf?AWSAccessKeyId=AKIAI4HFTKE6LGEX275A&Signature=VE0H%2FGptq%2FLg887FHIm6pyzKlAE%3D&Expires=1770342887',
        phone_home: '1234567890',
        phone_cell: '9876543210',
        phone_work: '4155556792',
        years_experience: 20,
        has_no_credentials: false,
        address_street: '123 Main St',
        address_apt: 'Apt 1',
        address_city: 'Portland',
        address_state: 'OR',
        address_zip: '97212',
        languages: [LanguagesEnum.ENGLISH],
      },
      certificates: [
        {
          label: 'Teaching Certificate',
          other_certificate_explanation: null,
        },
      ],
      credentials: [
        {
          id: 1,
          state: 5,
          subject: {
            id: 1,
            label: 'Art',
            credential_group: null,
            show_in_ats: true,
            show_in_connect: true,
            value: 'art',
          },
          grade: { id: 1, label: 'K-12', value: 'k_12' },
          status: { id: 1, label: 'Active', value: 'active' },
          expiration_date: '2025-12-31',
          license_number: 'CA-12345',
          issue_date: '2020-01-01',
          credential_explanation: null,
          credential_exams_passed: [],
          verification_status: CredentialVerificationStatus.PASSED_AUTO_VERIFICATION,
          screenshot_url: null,
          certificate: null,
          verified_on: null,
        },
      ],
      education: [
        {
          id: 1,
          degree: 3,
          university: 0,
          major_enum: 0,
          school: null,
          start_date: '2015-09-01',
          end_date: '2019-05-31',
        },
      ],
      exams: [
        {
          id: 1,
          type: 0,
          praxis_core_reading: 170,
          praxis_core_math: 165,
          praxis_core_writing: 172,
          act_composite: null,
          act_english: null,
          act_math: null,
          act_reading: null,
          act_science: null,
          cbest_math: null,
          cbest_reading: null,
          cbest_writing: null,
          gre_composite: null,
          gre_quantitative: null,
          gre_verbal: null,
          gre_writing: null,
          other_exam_name: null,
          other_exam_possible_score: null,
          other_exam_score: null,
          praxis_plt_score: null,
          praxis_subject: null,
          praxis_subject_score: null,
          sat_new_composite: null,
          sat_new_ebrw: null,
          sat_new_math: null,
          sat_old_composite: null,
          sat_old_math: null,
          sat_old_reading: null,
          sat_old_writing: null,
        },
      ],
      previous_positions: [],
      candidate_credential_status: CandidateCredentialStatus.ALL_VERIFIED,
      preferences: {
        categories: null,
        employment_type: null,
        grades: null,
        hours_per_week: '',
        location: '',
        miles_within: '',
        multilingual_school: null,
        title_1_school: null,
        turnaround_school: null,
      },
    },
    application: {
      id: 100,
      top_candidate: true,
      high_retention: true,
      prior_district_employee: true,
      source: {
        id: 0,
        label: 'Google',
      },
      questions: {
        applicationattachment_set: [
          {
            id: 1,
            attachment: 'https://google.com',
            title: 'My resume',
            file_size: 4567,
            file_type: 'pdf',
            file_name: 'myresume.docx',
          },
        ],
        applicationattachmentvideourl_set: [
          {
            id: 0,
            video_url: 'https://whatever.com',
            required_application_attachment_id: 123,
            title: 'Teaching demo',
          },
        ],
        custom_answers: [
          {
            question: 'Why are you interested in this teaching position?',
            answer:
              "I am passionate about making a difference in students' lives and believe this role aligns perfectly with my experience in elementary education. I'm drawn to your school`s commitment to innovative teaching methods and inclusive learning environments.",
            order: 0,
          },
          {
            question: 'Describe your classroom management style',
            answer:
              'I believe in creating a positive, structured environment where students feel safe and respected. I use a combination of clear expectations, consistent routines, and positive reinforcement. I also emphasize building strong relationships with students to foster mutual respect.',
            order: 3,
          },
          {
            question: 'How do you differentiate instruction for diverse learners?',
            answer:
              "I use formative assessments to understand each student's level and learning style. I implement tiered assignments, flexible grouping, and provide multiple ways for students to demonstrate understanding. I also collaborate with special education staff when needed.",
            order: 2,
          },
          {
            question: 'What experience do you have with technology in the classroom?',
            answer:
              "I've integrated various educational technologies including interactive whiteboards, learning management systems like Google Classroom, and educational apps. I believe technology should enhance learning, not replace meaningful teacher-student interactions.",
            order: 9,
          },
          {
            question: 'Do you have your license',
            answer: 'Yes',
            order: 4,
          },
          {
            question: 'What grade level is your experience',
            answer: 'Second, First',
            order: 5,
          },
          {
            question: 'I have my license',
            answer: 'Yes (box checked)',
            order: 19,
          },
        ],
      },
    },
  },
  {
    candidate_stage: null,
    has_references: false,
    role: {
      id: 0,
      title: '5th Grade English Teacher',
      status: roleStatusByValue.active,
      active_status: activeStatusByValue.activeOpen,
    },
    candidate: {
      id: 0,
      first_name: 'Catherine',
      last_name: 'Robbins',
      email: 'catherine@example.com',
      candidate_credential_status: CandidateCredentialStatus.SOME_VERIFIED,
      nimble_answers: [],
      preferences: {
        categories: null,
        employment_type: null,
        grades: null,
        hours_per_week: '',
        location: '',
        miles_within: '',
        multilingual_school: null,
        title_1_school: null,
        turnaround_school: null,
      },
      profile: {
        resume:
          'https://nimblemedia-dev.s3.us-west-1.amazonaws.com/resumes/46272/20230928_2236_template_resume.pdf?AWSAccessKeyId=AKIAI4HFTKE6LGEX275A&Signature=b5mJTQsYt9%2FGywWj6I4RlTvCIWQ%3D&Expires=1769108019',
        has_no_credentials: true,
        address_street: '345 Main',
        address_city: 'Portland',
        languages: [LanguagesEnum.AMERICAN_SIGN, LanguagesEnum.ENGLISH],
        years_experience: 1,
        address_zip: '97212',
        phone_cell: '1234567890',
      },
      certificates: [],
      credentials: [],
      education: [],
      previous_positions: [],
    },
    application: {
      id: 101,
      high_retention: false,
      prior_district_employee: false,
      source: {
        id: 0,
        label: 'Job board',
      },
      top_candidate: false,
      questions: {
        applicationattachment_set: [
          {
            id: 1,
            attachment:
              'https://nimblemedia-dev.s3.us-west-1.amazonaws.com/attachment/58013/20250218_165248_cowboy.pdf?AWSAccessKeyId=AKIAI4HFTKE6LGEX275A&Signature=wMf0P9WwRyWwnwfBgg%2F%2BCOcAV5E%3D&Expires=1770229875',
            title: 'My resume',
            file_size: 9999,
            file_type: 'jpg',
            file_name: 'myresume.jpg',
          },
        ],
        applicationattachmentvideourl_set: [
          {
            id: 0,
            video_url: 'https://whatever.com',
            required_application_attachment_id: 123,
            title: 'Teaching demo',
          },
        ],
        custom_answers: [
          {
            answer: 'passion',
            question: 'What is your top priority in a leader?',
            order: 0,
          },
        ],
      },
    },
  },
  {
    candidate_stage: null,
    has_references: false,
    role: {
      id: 0,
      title: '5th Grade Civics Teacher',
      status: roleStatusByValue.active,
      active_status: activeStatusByValue.activeOpen,
    },
    candidate: {
      id: 0,
      first_name: 'Josh',
      last_name: 'McDonald',
      email: 'josh@example.com',
      candidate_credential_status: CandidateCredentialStatus.NONE_VERIFIED,
      preferences: {
        categories: null,
        employment_type: null,
        grades: null,
        hours_per_week: '',
        location: '',
        miles_within: '',
        multilingual_school: null,
        title_1_school: null,
        turnaround_school: null,
      },
      nimble_answers: [],
      profile: {
        resume:
          'https://nimblemedia-dev.s3.us-west-1.amazonaws.com/resumes/46272/20230928_2236_template_resume.pdf?AWSAccessKeyId=AKIAI4HFTKE6LGEX275A&Signature=b5mJTQsYt9%2FGywWj6I4RlTvCIWQ%3D&Expires=1769108019',
        phone_home: '1234567890',
        phone_cell: '9876543210',
        phone_work: '4155556792',
        has_no_credentials: false,
        languages: [LanguagesEnum.ENGLISH],
        years_experience: 20,
        address_street: '456 Main St',
        address_city: 'Portland',
        address_zip: '97212',
      },
      certificates: [],
      credentials: [],
      education: [],
      previous_positions: [],
      exams: [],
    },
    application: {
      id: 102,
      high_retention: false,
      prior_district_employee: false,
      source: {
        id: 0,
        label: 'Job board',
      },
      top_candidate: true,
      questions: {
        applicationattachment_set: [
          {
            id: 1,
            attachment:
              'https://nimblemedia-dev.s3.us-west-1.amazonaws.com/attachment/58013/20250218_165248_cowboy.pdf?AWSAccessKeyId=AKIAI4HFTKE6LGEX275A&Signature=wMf0P9WwRyWwnwfBgg%2F%2BCOcAV5E%3D&Expires=1770229875',
            title: 'My resume',
            file_size: 12345,
            file_type: 'pdf',
            file_name: 'myresume.pdf',
          },
        ],
        applicationattachmentvideourl_set: [
          {
            id: 0,
            video_url: 'https://whatever.com',
            required_application_attachment_id: 123,
            title: 'Teaching demo',
          },
        ],
        custom_answers: [
          {
            answer: 'passion',
            question: 'What is your top priority in a leader?',
            order: 0,
          },
        ],
      },
    },
  },
  {
    candidate_stage: null,
    has_references: true,
    role: {
      id: 0,
      title: 'English Teacher',
      status: roleStatusByValue.active,
      active_status: activeStatusByValue.activeClosed,
    },
    candidate: {
      id: 0,
      first_name: 'Margaret',
      last_name: 'Horton',
      email: 'margaret@example.com',
      nimble_answers: [],
      profile: {
        resume:
          'https://nimblemedia-dev.s3.us-west-1.amazonaws.com/resumes/46272/20230928_2236_template_resume.pdf?AWSAccessKeyId=AKIAI4HFTKE6LGEX275A&Signature=b5mJTQsYt9%2FGywWj6I4RlTvCIWQ%3D&Expires=1769108019',
        phone_home: '1234567890',
        phone_cell: '9876543210',
        phone_work: '4155556792',
        has_no_credentials: false,
        languages: [],
        years_experience: 10,
        address_street: '789 Main St',
        address_city: 'Portland',
        address_zip: '97212',
      },
      certificates: [],
      credentials: [],
      education: [],
      previous_positions: [],
      candidate_credential_status: CandidateCredentialStatus.SOME_VERIFIED,
      preferences: {
        categories: null,
        employment_type: null,
        grades: null,
        hours_per_week: '',
        location: '',
        miles_within: '',
        multilingual_school: null,
        title_1_school: null,
        turnaround_school: null,
      },
    },
    application: {
      id: 103,
      high_retention: true,
      prior_district_employee: true,
      source: {
        id: 0,
        label: 'Job board',
      },
      top_candidate: false,
      questions: {
        applicationattachment_set: [
          {
            id: 1,
            attachment:
              'https://nimblemedia-dev.s3.us-west-1.amazonaws.com/attachment/58013/20250218_165248_cowboy.pdf?AWSAccessKeyId=AKIAI4HFTKE6LGEX275A&Signature=wMf0P9WwRyWwnwfBgg%2F%2BCOcAV5E%3D&Expires=1770229875',
            title: 'My resume',
            file_size: 12345,
            file_type: 'pdf',
            file_name: 'myresume.pdf',
          },
        ],
        applicationattachmentvideourl_set: [
          {
            id: 0,
            video_url: 'https://whatever.com',
            required_application_attachment_id: 123,
            title: 'Teaching demo',
          },
        ],
        custom_answers: [
          {
            answer: 'passion',
            question: 'What is your top priority in a leader?',
            order: 0,
          },
        ],
      },
    },
  },
];
